import { gql } from "lib/apolloClient";

export const fetchTranscriptV3BulkUploadExcelTemplateQuery = gql`
  query fetchTranscriptV3BulkUploadExcelTemplate(
    $input: FetchTranscriptV3BulkUploadExcelTemplateInput!
  ) {
    transcript {
      fetchTranscriptV3BulkUploadExcelTemplate(input: $input) {
        isSuccess
        url
      }
    }
  }
`;

export const getTranscriptV3BulkUploadTransactionQuery = gql`
  query getTranscriptV3BulkUploadTransaction(
    $id: ID!
    $filters: TranscriptV3BulkUploadTransactionSummaryFilters!
  ) {
    node(id: $id, type: TRANSCRIPT_V3_BULK_UPLOAD_TRANSACTION) {
      ... on TranscriptV3BulkUploadTransaction {
        id
        sheetType
        payload
        summaryRows(filters: $filters) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            id
            operationType
            rowIndex
            rowPayload
          }
        }
      }
    }
  }
`;

export const fetchTranscriptV3BulkUploadSkippedRowsExcelQuery = gql`
  query fetchTranscriptV3BulkUploadSkippedRowsExcel(
    $input: FetchTranscriptV3BulkUploadSkippedRowsExcelInput!
  ) {
    transcript {
      fetchTranscriptV3BulkUploadSkippedRowsExcel(input: $input) {
        isSuccess
        url
      }
    }
  }
`;
